
import { defineComponent, Ref, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useDriveStore } from '../../../../modules/drive/store/driveStore';
import BottomPopUpItem from '@/components/BottomPopUp/BottomPopUpItem.vue';
import AppBottomPopUp from '@/components/BottomPopUp/AppBottomPopUp.vue';
import AppLoader from '@/components/UI/AppLoader.vue';
import { MEDIA_TYPES } from '@/types/enums';
import { useMainStore } from '@/store/mainStore';

export default defineComponent({
  components: {
    BottomPopUpItem,
    AppBottomPopUp,
    AppLoader,
  },
  emits: ['add-case'],
  setup() {
    const router = useRouter();
    const driveStore = useDriveStore();
    const mainStore = useMainStore();

    const loader: Ref<string> = ref('');

    function hidePopUp() {
      mainStore.BottomPopUpType = null;
    }

    function addFolder() {
      mainStore.openCreateFolderPopUp();
      mainStore.BottomPopUpType = null;
    }

    function deleteFolder() {
      if (driveStore.currentFolder) {
        loader.value = 'Deleting folder';
        const upperFolderId = driveStore.currentFolder?.upperFolderId;
        driveStore.deleteFolder(driveStore.currentFolder.id).then((response) => {
          if (response.success) {
            if (upperFolderId) {
              router.push(`/drive/folder/${upperFolderId}/`).then(() => {
                loader.value = '';
                mainStore.BottomPopUpType = null;
              });
            } else {
              router.push('/drive/my/files').then(() => {
                loader.value = '';
                mainStore.BottomPopUpType = null;
              });
            }
          }
        });
      }
    }

    return {
      loader,
      hidePopUp,
      addFolder,
      deleteFolder,
      MEDIA_TYPES,
    };
  },
});
